module.exports = __webpack_public_path__ + "static/media/festival-tc.7598f0bf.jpg";